import { createFileRoute } from '@tanstack/react-router';
import { LandingPage } from '../../../components/landing';
import { useAuth } from '../../../context/auth-context';

export const Route = createFileRoute('/')({
  component: Index,
});

function Index() {
  const { isAuthenticated } = useAuth();

  return <LandingPage isAuthenticated={isAuthenticated} />;
}
